import { useParams } from 'react-router-dom';

interface RouteParams {
  categorySlug?: string
  dishListSlug?: string
  dishSlug?: string
  placeSlug?: string
}

export const useRouteParams = () => useParams<RouteParams>();
